<template>
  <div>
    <b-row align-v="center">
      <b-col>
        <h1 class="title-pages">{{ title }}</h1>
      </b-col>
      <b-col cols="auto">
        <slot name="top-right-button"></slot>
      </b-col>
    </b-row>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "TabContentLayout",

  props: {
    title: { type: String, required: true },
  },
};
</script>

<style>
</style>